import { useMutation } from '@tanstack/react-query';

import { prophetTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const toggleKeywordsPage: prophetTypes.ToggleKeywordsPage = (data) => {
  const { pageId, isEnabled } = data;
  if (isEnabled) {
    return axios.post(`/prophet/pages/disable-keywords`, { pageId });
  }
  return axios.post(`/prophet/pages/enable-keywords`, { pageId });
};

type ToggleKeywordPageOptions = {
  config?: MutationConfig<typeof toggleKeywordsPage>;
};

export function useToggleKeywordsPage({ config = {} }: ToggleKeywordPageOptions = {}) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['prophet-pages']);
      queryClient.invalidateQueries(['prophet-page']);
      queryClient.invalidateQueries(['prophet-page-audit']);
    },
    ...config,
    mutationFn: toggleKeywordsPage,
  });
}
